<div class="forgot-password-container">
  <div class="forgot-password-content">
    <mat-card class="forgot-password-card">
      <div class="header-content">
        <mat-icon class="header-icon">lock_reset</mat-icon>
        <h1 class="header-title">Şifre Sıfırlama</h1>
        <p class="header-subtitle">Şifrenizi sıfırlamak için e-posta adresinizi girin</p>
      </div>

      <mat-card-content>
        <form [formGroup]="forgetPasswordForm" (ngSubmit)="onSubmit()" class="forgot-password-form">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>E-posta Adresi</mat-label>
            <mat-icon matPrefix class="field-icon">email</mat-icon>
            <input matInput 
                   type="email" 
                   formControlName="email" 
                   placeholder=""
                   required>
            <mat-error *ngIf="forgetPasswordForm.get('email')?.hasError('required')">
              E-posta adresi gereklidir
            </mat-error>
            <mat-error *ngIf="forgetPasswordForm.get('email')?.hasError('email') && !forgetPasswordForm.get('email')?.hasError('required')">
              Geçerli bir e-posta adresi giriniz
            </mat-error>
          </mat-form-field>

          <div class="form-actions">
            <button mat-raised-button
                    type="submit"
                    class="submit-button"
                    [disabled]="!forgetPasswordForm.valid">
              <mat-icon>send</mat-icon>
              Sıfırlama Bağlantısı Gönder
            </button>

            <button mat-stroked-button
                    type="button"
                    class="back-to-login"
                    (click)="navigateToLogin()">
              <mat-icon>arrow_back</mat-icon>
              Giriş Sayfasına Dön
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
